import type { ApiFetchGiratudoStatusPort } from '~/handlers/ports/api-fetch-giratudo-status.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiFetchGiratudoStatusAdapter
  implements ApiFetchGiratudoStatusPort
{
  async handle(userId?: number | null) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const query =
      userId && userId > 0 ? `?user_id=${userId}` : '';

    const response = await fetch(
      `${getApostatudoApiUrl()}/hourly-raffle/status${query}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
        signal: controller.signal,
      },
    ).finally(() => clearTimeout(timeoutId));

    if (!response.ok) {
      throw new Error(`Failed to fetch raffle status: ${response.status}`);
    }

    const data = await response.json();

    return {
      raffleActive: data.raffle_active,
      alreadyParticipated: data.already_participated,
      eligible: data.eligible,
      raffleEndTime: data.raffle_end_time ?? null,
      participationEnabled: data.participation_enabled ?? true,
    };
  }
}
